import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { InvitationPage } from '../pages/Dashboard/invitation/invitation'
import { MenuSystem } from '../pages/Dashboard/menu-system/menu-system'
import { OrgTabInfo } from '../pages/Dashboard/organization/org-tab-info'
import { ReportsInfo } from './reports'
import { DashboardInfoPage } from '../pages/Dashboard/dashboard/dashboard'
import { RegistrationDetails } from '../pages/Dashboard/registrations/list'
import { BusinessUnits } from '../pages/Dashboard/business-units/list'
import { SettlementDetails } from '../pages/Dashboard/settlements/list'
import { Subscriptions } from '../pages/Dashboard/subscriptions/list'
import { Prevliges } from '../pages/Dashboard/previliges/previliges'
import { Tickets } from '../pages/Dashboard/tickets/list'
import { ProductInfo } from '../components/organization-tabs/org-products/product-info'
import { BusinessUnitDetails } from '../pages/Dashboard/organization/customers-list/online-connections/business-unit-details'
import { MessageView } from '../pages/Dashboard/tickets/messages'
import { OndcIgmData } from '../pages/Dashboard/ondc-igm/list'
import { ONDCIgmView } from '../pages/Dashboard/ondc-igm/info'
import { LogsData } from '../pages/Dashboard/logs/list'
import { SingleLogInfo } from '../pages/Dashboard/logs/logInfo'
import { OrderView } from '../pages/Dashboard/organization/ondc-orders/orders/order-view'
import { TotalOrdersList } from '../pages/Dashboard/organization/ondc-orders/total orders/list'
import { ONDCOrdersView } from '../pages/Dashboard/organization/ondc-orders/total orders/orders-view'
import { UserView } from '../components/organization-tabs/org-users/user-view'
import { TransactionInvoiceData } from '../pages/Dashboard/transactionInvoices/transaction-invoice-view'
import { RetailInvoiceView } from '../pages/Dashboard/retailerInvoices/retail-invoice-view'
import { TransactionDetailsView } from '../pages/Dashboard/organization/customers-list/transaction-details'
import { SubscriptionData } from '../pages/Dashboard/organization/subscriptions/list'
import { CRMNotes } from '../pages/Dashboard/crm/notes/notes'
import { OrganizationsList } from '../pages/Dashboard/organization/list'
import { VendorsList } from '../pages/Dashboard/crm/customer-list/list'
import { CustomerTabs } from '../pages/Dashboard/crm/customer-list/customer-view'
import { Reminders } from '../pages/Dashboard/crm/customer-list/customer-view/reminders'
import { CustomerChat } from '../pages/Dashboard/customer-chat'


export const DashboardRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<DashboardInfoPage />}></Route>
        <Route path="/info" element={<DashboardInfoPage />}></Route>
        <Route path='/registration' element={<RegistrationDetails/>}></Route>
        <Route path="/business-units" element={<BusinessUnits />}></Route>
        <Route path="/organizations" element={<OrganizationsList />}></Route>
        <Route path="/organizations/org-details/:page/:org/:tabRoute" element={<OrgTabInfo />} />
        <Route path="/invitation" element={<InvitationPage />}></Route>
        <Route path="/settlements" element={<SettlementDetails/>}></Route>
        <Route path="/menu-system" element={<MenuSystem type='system' />}></Route>
        <Route path="/reports" element={<ReportsInfo />}></Route>
        {/* <Route path='/subscriptions' element={<Subscriptions/>}></Route> */}
        <Route path='/previliges' element={<Prevliges/>}></Route>
        <Route path='/tickets' element={<Tickets/>}></Route>
        <Route path='/tickets/:id' element={<MessageView/>}></Route>
        <Route path='/organizations/org-details/:page/:org/products/:productId' element={<ProductInfo/>}></Route>
        <Route path='/organizations/org-details/:page/:org/online-connections/:buId/:type/view' element={<BusinessUnitDetails/>}></Route>
        <Route path='/organizations/org-details/:page/:org/online-connections/:buId/:type/transaction' element={<TransactionDetailsView/>}></Route>
        <Route path='/organizations/org-details/:page/:org/offline-connections/:buId/:type/transaction' element={<TransactionDetailsView/>}></Route>
        <Route path="/ondc-igm" element={<OndcIgmData/>}></Route>
        <Route path="/ondc-igm/:id" element={<ONDCIgmView/>}></Route>
        <Route path='/logs' element={<LogsData/>}></Route>
        <Route path='/logs/:id' element={<SingleLogInfo/>}></Route> 
        <Route path='/organizations/org-details/:org/ondc-orders/:id/view' element={<OrderView/>}></Route>
        <Route path='/ondc-orders' element={<TotalOrdersList/>}></Route>
        <Route path='/ondc-orders/:id/view' element={<ONDCOrdersView/>}></Route>
        <Route path='/organizations/org-details/:page/:org/users/:id/info' element={<UserView/>}></Route>
        <Route path='/organizations/org-details/:page/:org/transaction/:id/view' element={<TransactionInvoiceData/>}></Route>
        <Route path='/subscriptions' element={<OrganizationsList/>}></Route>
        <Route path='/organizations/org-details/:page/:org/retailer/:id/view' element={<RetailInvoiceView/>}></Route>
        <Route path='/subscriptions/:buId/view' element={<SubscriptionData/>}></Route>
        <Route path='/crm' element={<CRMNotes/>}></Route>
        <Route path='/organizations/org-details/:org/ticket/:id' element={<MessageView/>}></Route>
        <Route path='/crm/vendors-list' element={<VendorsList/>}></Route>
        <Route path='/crm/vendors-list/:id/:route' element={<CustomerTabs/>}></Route>
        <Route path='/crm/vendors-list/reminders' element={<Reminders/>}></Route>
        <Route path='/customer-chat' element={<CustomerChat/>}></Route>
      </Routes>
    </div>
  )
}
